export function scrollHighlight() {

  jQuery(function () {

    //基準点の準備
    var elemTop = [];

    //現在地を取得するための設定を関数でまとめる
    function PositionCheck(){
        //headerの高さを取得
      var headerH = $(".l-header").outerHeight(true);
        //.scroll-pointというクラス名がついたエリアの位置を取得する設定
      $(".scroll-point").each(function(i) {//.scroll-pointクラスがついたエリアからトップまでの距離を計算して設定
        elemTop[i] =Math.round(parseInt($(this).offset().top-headerH));//追従するheader分の高さ（70px）を引き小数点を四捨五入
      });
    }

    //ナビゲーションに現在地のクラスをつけるための設定
    function ScrollAnime() {//スクロールした際のナビゲーションの関数にまとめる
      var scroll = Math.round($(window).scrollTop());
      //var NavElem = $(".guideList li");//ナビゲーションのliの何番目かを定義するための準備
      $(".p-memberPersonal").removeClass('current_0');//全てのナビゲーションの現在地クラスを除去
      $(".p-memberPersonal").removeClass('current_1');//全てのナビゲーションの現在地クラスを除去
      $(".p-memberPersonal").removeClass('current_2');//全てのナビゲーションの現在地クラスを除去
      $(".p-memberPersonal").removeClass('current_3');//全てのナビゲーションの現在地クラスを除去
      $(".p-memberPersonal").removeClass('current_4');//全てのナビゲーションの現在地クラスを除去
      $(".p-memberPersonal").removeClass('current_5');//全てのナビゲーションの現在地クラスを除去
      $(".p-memberPersonal").removeClass('current_6');//全てのナビゲーションの現在地クラスを除去
      $(".p-memberPersonal").removeClass('last');//全てのナビゲーションの現在地クラスを除去
      if(scroll >= 0 && scroll < elemTop[1]) {//スクロール値が0以上 .scroll-point 1つめ（area-1）の高さ未満
          //$(NavElem[0]).addClass('current');//1つめのliに現在地クラスを付与
          $('.p-memberPersonal').addClass('current_0');
        }
        else if(scroll >= elemTop[1] && scroll < elemTop[2]) {//.scroll-point 1つめ（area-1）以上.scroll-point 2つめ（area-2）未満
          //$(NavElem[1]).addClass('current');//2つめのliに現在地クラスを付与
          $('.p-memberPersonal').addClass('current_1');
        } 
        else if(scroll >= elemTop[2] && scroll < elemTop[3]) {
          $('.p-memberPersonal').addClass('current_2');
        }
        else if(scroll >= elemTop[3] && scroll < elemTop[4]) {
          $('.p-memberPersonal').addClass('current_3');
        } 
        else if(scroll >= elemTop[4] && scroll < elemTop[5]) {
          $('.p-memberPersonal').addClass('current_4');
        } 
        else if(scroll >= elemTop[5] && scroll < elemTop[6]) {
          $('.p-memberPersonal').addClass('current_5');
        } 
        else if(scroll >= elemTop[6]) {
          $('.p-memberPersonal').addClass('current_6');
        } 
        else{
          $('.p-memberPersonal').addClass('last');
        }
    }

    //ナビゲーションをクリックした際のスムーススクロール
    // $('#aboutNav a').click(function () {
    //   var elmHash = $(this).attr('href'); //hrefの内容を取得
    //   var headerH = $("#header").outerHeight(true);//追従するheader分の高さ（70px）を引く
    //   var pos = Math.round($(elmHash).offset().top-headerH);  //headerの高さを引き小数点を四捨五入
    //   $('body,html').animate({scrollTop: pos}, 500);//取得した位置にスクロール※数値が大きいほどゆっくりスクロール
    //   return false;//リンクの無効化
    // });


    // 画面をスクロールをしたら動かしたい場合の記述
    $(window).scroll(function () {
      PositionCheck();/* 現在地を取得する関数を呼ぶ*/
      ScrollAnime();/* ナビゲーションに現在地のクラスをつけるための関数を呼ぶ*/
    });

    // ページが読み込まれたらすぐに動かしたい場合の記述
    $(window).on('load', function () {
      PositionCheck();/* 現在地を取得する関数を呼ぶ*/
      ScrollAnime();/* ナビゲーションに現在地のクラスをつけるための関数を呼ぶ*/
    });

    $(window).resize(function() {
      //リサイズされたときの処理
      PositionCheck()
    });

    /*----------------------
    スクロール中だけアクティブ
    ----------------------*/

    if (window.matchMedia('(min-width: 768px)').matches) {
      var timeoutId ;

      window.addEventListener( "scroll", function () {
        let element = document.getElementById('aboutNav');
        if (element !== null){
          element.classList.add( "opacityActive" ) ;
          clearTimeout( timeoutId ) ;

          timeoutId = setTimeout(function(){
            element.classList.remove("opacityActive");
          },1500);
        }
        
      });
    }
    

    /*----------------------
    open close
    ----------------------*/
    $('.p-aboutNav_btn').click(function () {
      if($('.p-aboutNav').hasClass('active')){
        $('.p-aboutNav').removeClass('active');
      }else{
          $(this).addClass('active');
          $('.p-aboutNav').addClass('active');
      }
    });

  });

}
